import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie
import versionCheck from '@/utils/versionCheck'
// import { pollingBeforeHook } from '@/utils/intermediary'
import { mgr } from '@/utils/oidc'
import { logoutFn } from '@/utils/logout'
import { ViewCoreOperations } from '@/api/identityApi'
import { getUserBrandPermission, getUserShopPermission } from '@/utils/priceSystem'

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

/**
 * /getFile 查看文件
 */
const whiteList = ['/auth-redirect', '/heroesRank', 'dataVisualization', '/getFile', '/callback'] // no redirect whitelist
const isDev = process.env.NODE_ENV === 'development'
if (isDev) {
  whiteList.push('/login')
}

const AUTH_DEBUG_IFRAME_STORAGE_KEY = 'OAK_AUTH_DEBUG_IFRAME_DATA'
const AUTH_DEBUG_IFRAME_DATA_MAX_AGE = 60 * 1000
let authorizationDebugIframeData = readAuthorizationDebugIframeData()

window.addEventListener('message', getVueMsg)
function getVueMsg(event) {
  const res = event.data
  if (res.cmd === 'myIframe') {
    authorizationDebugIframeData = res.params || {}
    console.log('[AuthorizationDebug][iframe-permission] receive debug token by postMessage', {
      authorizationCode: authorizationDebugIframeData.authorizationCode,
      hasToken: !!authorizationDebugIframeData.token
    })
    getIframeTnfo(authorizationDebugIframeData)
  }
}

function isInIframe() {
  try {
    return window.self !== window.top
  } catch (error) {
    return true
  }
}

function readAuthorizationDebugIframeData() {
  if (!isInIframe()) {
    return {}
  }
  try {
    const rawData = localStorage.getItem(AUTH_DEBUG_IFRAME_STORAGE_KEY)
    const debugData = rawData ? JSON.parse(rawData) : {}
    if (debugData.token) {
      const dataAge = new Date().getTime() - Number(debugData.createdAt || 0)
      if (dataAge > AUTH_DEBUG_IFRAME_DATA_MAX_AGE) {
        localStorage.removeItem(AUTH_DEBUG_IFRAME_STORAGE_KEY)
        console.warn('[AuthorizationDebug][iframe-permission] startup debug token expired', {
          authorizationCode: debugData.authorizationCode,
          createdAt: debugData.createdAt,
          dataAge
        })
        return {}
      }
      console.log('[AuthorizationDebug][iframe-permission] read startup debug token', {
        authorizationCode: debugData.authorizationCode,
        createdAt: debugData.createdAt,
        dataAge
      })
    } else {
      console.warn('[AuthorizationDebug][iframe-permission] startup debug token missing')
    }
    return debugData
  } catch (error) {
    console.error('[AuthorizationDebug][iframe-permission] read startup debug token failed', error)
    return {}
  }
}

// 获取授权人用户信息
function getIframeTnfo(iframeData) {
  console.log('[AuthorizationDebug][iframe-permission] refresh user info with debug token', {
    authorizationCode: iframeData.authorizationCode,
    hasToken: !!iframeData.token
  })
  store.dispatch('GetUserInfo', iframeData).then(res => { // 拉取user_info
    const roles = []
    for (var i = 0; i < res.data.res_content.roles.length; i++) {
      roles.push(res.data.res_content.roles[i].role_code)
    }
    store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
      router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表 console.log(router)
      console.log('[AuthorizationDebug][iframe-permission] debug user routes generated', {
        authorizationCode: iframeData.authorizationCode,
        roles
      })
    })
  }).catch((err) => {
    console.error('[AuthorizationDebug][iframe-permission] refresh user info failed', err)
  })
}

function getPricingAuthorization(path) {
  // 价格管理---权限控制信息
  const brands = localStorage.getItem('brands')
  const shops = localStorage.getItem('shops')
  if (!brands && path.includes('priceSystem')) {
    getUserBrandPermission()
  }
  if (!shops && path.includes('priceSystem')) {
    getUserShopPermission()
  }
}

router.beforeEach((to, from, next) => {
  if (to.path === '/login' && !isDev) {
    localStorage.removeItem('access_token')
  }
  NProgress.start() // start progress bar
  if ((isDev && getToken()) || localStorage.getItem('access_token')) { // determine if there has token
    // 只在有token且不在登录页时才获取价格权限，避免环境切换时登录页循环刷新
    if (to.path !== '/login') {
      getPricingAuthorization(to.path)
    }
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        const debugIframeData = authorizationDebugIframeData.token ? authorizationDebugIframeData : undefined
        const inIframe = isInIframe()
        if (inIframe || debugIframeData) {
          console.log('[AuthorizationDebug][iframe-permission] beforeEach GetUserInfo', {
            path: to.path,
            isIframe: inIframe,
            authorizationCode: debugIframeData && debugIframeData.authorizationCode,
            useDebugToken: !!(debugIframeData && debugIframeData.token)
          })
        }
        store.dispatch('GetUserInfo', debugIframeData).then(res => { // 拉取user_info
          const roles = []
          for (var i = 0; i < res.data.res_content.roles.length; i++) {
            roles.push(res.data.res_content.roles[i].role_code)
          }
          store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表 console.log(router)
            versionCheck(to, from, function() {
              next({ ...to, replace: true })
            })
            // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
        }).catch((err) => {
          if (isDev) {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          } else {
            const params = {
              name: 'oak获取账户权限', // 事件名称
              category: 'GetFunction', // 事件类别
              eventType: 'Failure', // 事件类型
              message: JSON.stringify(err), // 事件信息
              url: to.path, // 前端地址栏路由
              data: null // 事件详细信息
            }
            ViewCoreOperations(params).finally(() => {
              Message({
                message: '系统|账号问题，请联系IT管理员',
                type: 'info',
                duration: 4 * 1000
              })
              // 设置cookie:.shjinjia.com.cn
              setTimeout(() => {
                logoutFn()
              }, 2000)
            })
          }
        })
      } else {
        // 媒介页面异常监控
        // pollingBeforeHook(to, from)

        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (hasPermission(store.getters.roles, to.meta.roles)) {
          versionCheck(to, from, function() {
            next()
          })
          // next()
        } else {
          next({ path: '/401', replace: true, query: { noGoBack: true }})
        }
        // 可删 ↑
      }
    }
  } else {
    // 清除首次登录的存储数据
    localStorage.getItem('mediaObj') && localStorage.removeItem('mediaObj')
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      versionCheck(to, from, function() {
        next()
      })
    } else {
      if (isDev) {
        next({
          path: '/login', query: { redirect: to.path, ...to.query }
        })
        NProgress.done()
      } else {
        if (getToken()) {
          removeToken()
        }
        mgr.signinRedirect({ state: window.location.href })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
